var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultiLvSelect',_vm._g(_vm._b({ref:"MultiLvSelect",attrs:{"data":_vm.industryInfo,"props":_vm.props}},'MultiLvSelect',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }